import { useState } from "react";
import { useNavigate } from "react-router-dom";

const stats = [
  { value: "12,800+", label: "收录影视作品" },
  { value: "36", label: "细分类型标签" },
  { value: "每日", label: "影视资讯更新" },
  { value: "4.8", label: "用户平均评分" },
];

export default function AboutBrief() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  return (
    <section className="w-full px-4 md:px-6 pt-14 md:pt-20">
      <div className="relative w-full rounded-lg overflow-hidden bg-primary-950">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20background%20of%20a%20movie%20theatre%20with%20deep%20navy%20seats%20and%20a%20single%20warm%20orange%20spotlight%20beam%20cutting%20through%20haze%2C%20atmospheric%20dust%20particles%2C%20minimal%20elegant%20editorial%20composition%2C%20high%20contrast&width=1600&height=700&seq=cc-about-band&orientation=landscape"
          alt="CC视频影院氛围背景"
          title="CC视频 - 专业影视视频平台"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-primary-950/40" />

        <div className="relative z-10 px-5 md:px-12 py-10 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-1.5 text-[11px] font-label tracking-[0.18em] uppercase text-accent-400 mb-3">
                <span className="w-4 h-px bg-accent-500" />
                About CC视频
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                一个把「找到好片」这件事
                <br className="hidden md:block" />
                做得更体面的影视平台
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
                CC视频聚合电影与电视剧的完整信息——演职员、类型、地区、年份、评分与简介，
                并用清晰的筛选与搜索，让你在几分钟内锁定想看的那一部。
              </p>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const q = keyword.trim();
                  navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
                }}
                className="mt-6 flex flex-col sm:flex-row gap-2 max-w-lg"
              >
                <div className="flex-1 flex items-center h-11 rounded-md bg-background-50/10 border border-background-50/25 px-3 focus-within:border-accent-400 transition-colors">
                  <i className="ri-search-line text-background-300 text-base w-4 h-4 flex items-center justify-center" />
                  <input
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    placeholder="输入片名、导演或演员"
                    className="flex-1 min-w-0 bg-transparent px-2 text-sm text-background-50 outline-none placeholder:text-background-300/80"
                  />
                </div>
                <button
                  type="submit"
                  className="h-11 px-6 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即搜索
                </button>
              </form>
            </div>

            <div className="lg:col-span-5 grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-md border border-background-50/15 bg-background-50/5 px-4 py-4"
                >
                  <p className="font-label text-xl md:text-2xl font-extrabold text-background-50 tabular-nums">
                    {s.value}
                  </p>
                  <p className="mt-1 text-[11px] md:text-xs text-background-300">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}